import {fetchAPI} from './api'
export async function getPreviewPost(id: number, idType = 'DATABASE_ID') {
    const data = await fetchAPI(
      `
      query PreviewPost($id: ID!, $idType: PostIdType!) {
        post(id: $id, idType: $idType) {
          databaseId
          slug
          status
        }
      }`,
      {
        variables: { id, idType },
      }
    );
    return data.post;
  }
  
  export async function getAllPostsWithSlug() {
    const data = await fetchAPI(`
      {
        posts(first: 10000) {
          edges {
            node {
              slug
            }
          }
        }
      }
    `);
    return data?.posts;
  }
  
  export async function getAllPostsForHome(preview: boolean) {
    const data = await fetchAPI(
      `query AllPosts {
        posts(first: 20, where: { orderby: { field: DATE, order: DESC } }) {
          nodes {
              id
              uri
              title
              excerpt
              content
              date
              slug
              featuredImage {
                node {
                  sourceUrl
                }
              }
              author {
                node {
                  name
                  slug
                }
              }
              categories {
                nodes {
                  name
                  slug
                }
              }
            }
        }
      }
    `,
      {
        variables: {
          onlyEnabled: !preview,
          preview,
        },
      }
    );
  
    return data?.posts;
  }
  
  
  
  export async function getPostAndMorePosts(slug: string, preview: boolean, previewData: any) {
    const postPreview = preview && previewData?.post;
    const isId = Number.isInteger(Number(slug));
    const isSamePost = isId
      ? Number(slug) === postPreview.id
      : slug === postPreview.slug;
    const isDraft = isSamePost && postPreview?.status === 'draft';
    const isRevision = isSamePost && postPreview?.status === 'publish';
    const data = await fetchAPI(
      `
      fragment AuthorFields on User {
        name
        firstName
        lastName
        avatar {
          url
        }
      }
      fragment PostFields on Post {
        title
        excerpt
        slug
        date
        featuredImage {
          node {
            sourceUrl
          }
        }
        author {
          node {
            ...AuthorFields
          }
        }
        categories {
          edges {
            node {
              name
              slug
            }
          }
        }
        tags {
          edges {
            node {
              name
            }
          }
        }
      }
      query PostBySlug($id: ID!, $idType: PostIdType!) {
        post(id: $id, idType: $idType) {
          ...PostFields
          content
          ${
            isRevision
              ? `
          revisions(first: 1, where: { orderby: { field: MODIFIED, order: DESC } }) {
            edges {
              node {
                title
                excerpt
                content
                author {
                  node {
                    ...AuthorFields
                  }
                }
              }
            }
          }
          `
              : ''
          }
        }
        posts(first: 3, where: { orderby: { field: DATE, order: DESC } }) {
          edges {
            node {
              ...PostFields
            }
          }
        }
      }
    `,
      {
        variables: {
          id: isDraft ? postPreview.id : slug,
          idType: isDraft ? 'DATABASE_ID' : 'SLUG',
        },
      }
    );
  
    if (isDraft) data.post.slug = postPreview.id;
    if (isRevision && data.post.revisions) {
      const revision = data.post.revisions.edges[0]?.node;
      if (revision) Object.assign(data.post, revision);
      delete data.post.revisions;
    }
  
    data.posts.edges = data.posts.edges.filter(({ node }: { node: any }) => node.slug !== slug);
  
    if (data.posts.edges.length > 2) data.posts.edges.pop();
  
    return data;
  }
  
  
  
  export async function getRecentPosts() {
    const data = await fetchAPI(
      `
      {
        posts(first: 3, where: { orderby: { field: DATE, order: DESC } }) {
          edges {
            node {
              id
              title
              date
              content
              slug
              featuredImage {
                node {
                  sourceUrl
                  altText
                }
              }
              categories {
                nodes {
                  name
                  slug
                }
              }
            }
          }
        }
      }
    `
    );
  
    return data?.posts;
  }
  
  export async function getAllCategories() {
    const data = await fetchAPI(`
      {
        categories {
          nodes {
            name
            slug
          }
        }
      }
    `);
  
    // Extracting the categories and returning as an array of objects with name and slug properties
    const categories = data?.categories?.nodes || [];
    return categories.map((category: any) => ({
      name: category.name,
      slug: category.slug,
    }));
  }
  export async function getPostsPerPage() {
    const query = `
    query getPostsperpage {
      allSettings {
        readingSettingsPostsPerPage
      }
    }
    `;
  
    try {
      const data = await fetchAPI(query);
      const postsPerPage = data?.allSettings?.readingSettingsPostsPerPage || null;
      
      return postsPerPage;
    } catch (error) {
      console.error('Error fetching posts per page:', error);
      return null;
    }
}